module.exports = __webpack_public_path__ + "static/media/67.5d3b1e17.jpg";